import client from './api-client';

// RG-580 — revisión del informe de defensa penal por el analista (tareas WFL 91 y 94).
// El `client.get` de este repo apunta al API Gateway Internos (urlBase de api-client.js).

// «Guardar Revisión» (lambda defensa-fnc-revisa-informe-penal). El cuerpo no lleva usuario, perfil ni trx: el servidor los calcula.
// Devuelve la respuesta del servidor ({ code, object, message }) para mostrar su mensaje.
export const servicePostRevisaInformePenal = async (body) => {
    try {
        const response = await client.post('revisa-informe-penal', body);
        return response.data;
    } catch (error) {
        throw error;
    }
}

// Lee el informe pendiente de revisión del caso (modo `revision` del lambda defensa-fnc-obtiene-informe-penal).
// `query` = base64 de { modo: 'revision', idCaso }. Ante code distinto de 1 lanza un Error con el mensaje del servidor.
export const serviceGetRevisionInformePenal = async (query) => {
    try {
        const response = await client.get(`consulta/informe-defensa-penal?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } catch (error) {
        throw error;
    }
}
